/** Animate a tile move from the positions visible before the DOM changes. */
export class TileMotion {
  private readonly positions = new Map<Element, DOMRect>();

  constructor(private readonly card: Element) {
    const reduced = card.ownerDocument.defaultView?.matchMedia?.(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    if (reduced === true || typeof card.animate !== "function") {
      return;
    }
    for (const tile of card.querySelectorAll(".cb-fuxi-tile")) {
      this.positions.set(tile, tile.getBoundingClientRect());
    }
    // Capture an interrupted move before cancelling its transform.
    for (const tile of this.positions.keys()) {
      for (const animation of tile.getAnimations()) {
        if (animation.id === "cb-fuxi-move") {
          animation.cancel();
        }
      }
    }
  }

  /** Slide the moved tile and its neighbors to their new positions. */
  finish(source: Element, destination: Element, origin?: DOMRect): void {
    if (this.positions.size === 0) {
      return;
    }
    const from = origin ?? this.positions.get(source)!;
    this.positions.set(destination, from);
    for (const tile of this.card.querySelectorAll(".cb-fuxi-tile")) {
      const before = this.positions.get(tile)!;
      const after = tile.getBoundingClientRect();
      if (before.width === 0 || after.width === 0) {
        continue;
      }
      const x = before.left + before.width / 2 - after.left - after.width / 2;
      const y = before.top + before.height / 2 - after.top - after.height / 2;
      if (x === 0 && y === 0) {
        continue;
      }
      tile.animate(
        [
          { transform: `translate(${String(x)}px, ${String(y)}px)`, zIndex: 1 },
          { transform: "translate(0, 0)", zIndex: 1 },
        ],
        {
          id: "cb-fuxi-move",
          duration: 260,
          easing: "cubic-bezier(0.2, 0.8, 0.2, 1)",
        },
      );
    }
  }
}
